(async () => {
    const { Core } = await importModule('Core');
    const { $replaceContent, $toggleDisplay } = await importModule('Utils');

    customElements.define('x-cart', class extends Core {
        elements = {
            itemsContainer: '[data-cart-items-container]',
            emptyMsg: '[data-cart-empty]',
            items: '[data-cart-items]',
            subtotalBlock: '[data-cart-subtotal-block]'
        }
        
        subscriptions = {
            'cart:update': '_onUpdate',
        }

        render() {
            this.subscribe('cart:update', { global: true });
        };

        _onUpdate(data) {
            const hasCartItems = data.getCount() > 0;
            this._toggleView(hasCartItems);
            hasCartItems && this._updateItems(data);
        }

        _toggleView(state) {
            $toggleDisplay(this.$emptyMsg, !state)
            $toggleDisplay(this.$itemsContainer, state)
        }

        _updateItems({ getItems, getSubtotalBlock }) {
            $replaceContent(this.$subtotalBlock, getSubtotalBlock());
            $replaceContent(this.$items, getItems());
        }
    });
})();